import { EnergyBillEnum, EnergyCostMonthEnum, InterestedSolarEnergyForEnum, InterestOtherEnergySolutionsEnum, PropertyTypeEnum } from "../enum";
import { ReasonNotConvertedEnum } from "../enum/Leads";
import { IKanban, ILeadDetailed, ILeads, IUpdateStatusKanban } from "../interfaces/Leads";
import BaseApi from "./BaseApi";

const baseUrl = 'api/leads/';

interface IGetLead {
    document: string;
    email: string;
    invoiceAmount: number;
    id: string;
    firstName: string;
    lastName: string;
    phone: string;
    product: string;
    status: number;
    conversationHistory: string;
    company: string;
    numberAddress: string;
    street: string;
    city: string;
    state: string;
    country: string;
    complement: string;
    postalCode: string;
    createdBySalesForce: boolean;
    interestOtherEnergySolutions?: InterestOtherEnergySolutionsEnum;
    interestedSolarEnergyFor?: InterestedSolarEnergyForEnum;
    propertyType?: PropertyTypeEnum;
    energyCostMonth?: EnergyCostMonthEnum;
    energyBill?: EnergyBillEnum;
    observation?: string;
    reasonNotConverted?: ReasonNotConvertedEnum;
    reasonOther?: string;
}

interface ILeadDetailedResponse {
    success: boolean;
    data: ILeadDetailed | string[];
}

interface IResponse {
    success: boolean;
    data: any;
    errors: string[];
}

class LeadsService {
    //#region GET
    static async getLead(id: string): Promise<IGetLead> {
        return BaseApi.get(`${baseUrl}${id}`);
    }

    static async getLeadDetailed(id: string): Promise<ILeadDetailedResponse> {
        return BaseApi.get(`${baseUrl}${id}/detailed`);
    }

    static async getKanban(): Promise<IKanban[]> {
        return BaseApi.get(`${baseUrl}kanban`);
    }

    static async getToReport(filter?: any): Promise<{ data: ILeads[], totalPage: number }> {
        return BaseApi.get(`${baseUrl}report`, {
            params: filter
        });
    }
    //#endregion
    //#region POST 
    static async postNewLead(request: any): Promise<IResponse> {
        return BaseApi.post(baseUrl, request);
    }
    //#endregion
    //#region PUT
    static async putEditLead(request: any, id: string): Promise<IResponse> {
        return BaseApi.put(`${baseUrl}${id}`, request);
    }

    static async putChangeStatus(id: string, request: any): Promise<IResponse> {
        return BaseApi.put(`${baseUrl}${id}/status`, request, { headers: { 'Content-Type': 'application/json' } });
    }

    static async putInteraction(request: FormData): Promise<IResponse> {
        return BaseApi.put(`${baseUrl}interaction`, request);
    }
    //#endregion
    //#region PATCH
    static async patchStatusKanban(request: IUpdateStatusKanban[]): Promise<IResponse> {
        return BaseApi.patch(`${baseUrl}kanban`, request);
    }
    //#endregion
}

export default LeadsService;
